import React from 'react';
import Icon from '../../../components/AppIcon';


const HeroSection = ({ onSearchChange, searchQuery }) => {
  return (
    <section className="relative bg-gradient-brand text-white py-20 lg:py-24 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 border border-white/20 rounded-full"></div>
        <div className="absolute top-32 right-20 w-24 h-24 border border-white/20 rounded-full"></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-white/20 rounded-full"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto">
          {/* Navigation Breadcrumb */}
          <div className="flex items-center justify-center space-x-2 text-white/80 text-sm mb-6">
            <Icon name="Home" size={16} />
            <span>/</span>
            <span>Knowledge Hub</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-hero mb-6">
            Knowledge Hub
            <span className="block text-secondary mt-2">Thought Leadership Center</span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl lg:text-2xl text-white/90 mb-8 leading-relaxed">
            Navigate the complex world of data strategy with expert insights, practical frameworks, 
            and actionable resources designed for modern data leaders.
          </p>

          {/* Search Bar */}
          <div className="max-w-2xl mx-auto mb-8">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                <Icon name="Search" size={20} color="rgb(148 163 184)" />
              </div>
              <input
                type="text"
                placeholder="Search articles, frameworks, tools, and resources..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e?.target?.value)}
                className="w-full pl-12 pr-4 py-4 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl text-white placeholder-white/60 focus:outline-none focus:ring-2 focus:ring-secondary focus:border-transparent transition-all duration-300"
              />
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-secondary mb-1">150+</div>
              <div className="text-sm text-white/80">Expert Articles</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-secondary mb-1">25+</div>
              <div className="text-sm text-white/80">Frameworks</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-secondary mb-1">40+</div>
              <div className="text-sm text-white/80">Tools & Templates</div>
            </div>
            <div className="text-center">
              <div className="text-2xl lg:text-3xl font-bold text-secondary mb-1">12+</div>
              <div className="text-sm text-white/80">Webinars</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;